<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><g clip-path="url(#a)"><path fill-rule="evenodd" d="M10 8.5A1.5 1.5 0 008.5 10v8a1.5 1.5 0 003 0v-4.379l11 11V38a1.5 1.5 0 003 0V24a1.5 1.5 0 00-.44-1.06L13.622 11.5H18a1.5 1.5 0 000-3h-8zm26.5 5.121V18a1.5 1.5 0 003 0v-8A1.5 1.5 0 0038 8.5h-8a1.5 1.5 0 000 3h4.379l-6.44 6.44a1.5 1.5 0 002.122 2.12l6.439-6.439z"/></g><defs><clipPath id="a"><path d="M0 0h48v48H0z"/></clipPath></defs></svg>